<mat-card>
  <app-card-header
    icono="gps_fixed"
    [title]="title"
    [subtitle]="subtitle"
    [draggable]="true"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (!loading) {
    @if (form) {
      <form
        id="form"
        [formGroup]="form"
        autocomplete="off"
        (ngSubmit)="onSubmit()"
      >
        <mat-card-content
          [class.cardContentDialog]="dialogRef"
          class="card-content-crear"
        >
          <!-- Datos del Tracker -->
          <app-content-card
            title="Datos del Tracker"
            icon="gps_fixed"
            color="blue"
          >
            <!-- Nombre e Identificación -->
            <section class="inputs-group">
              <mat-form-field style="width: 100%">
                <mat-label>Nombre</mat-label>
                <input matInput formControlName="nombre" />
                <mat-icon matPrefix>label</mat-icon>
              </mat-form-field>

              <mat-form-field style="width: 100%">
                <mat-label>Identificación</mat-label>
                <input matInput formControlName="identificacion" />
                <mat-icon matPrefix>badge</mat-icon>
              </mat-form-field>
            </section>

            <!-- Tipo y Modelo -->
            <section class="inputs-group">
              <div style="width: 100%">
                <label class="field-label">Tipo</label>
                <ng-select
                  [fixedPlaceholder]="true"
                  [items]="tipos"
                  formControlName="tipo"
                  [multiple]="false"
                  placeholder="Tipo de tracker"
                  [notFoundText]="'No hay tipos disponibles'"
                  appendTo="body"
                ></ng-select>
              </div>

              <div style="width: 100%">
                <label class="field-label">Modelo</label>
                <app-modelo-dispositivo-selector
                  tipo="Tracker"
                  formControlName="idModelo"
                  [showCrearBtn]="
                    helper.tienePermiso(
                      'Configuraciones - Crear modelos trackers'
                    )
                  "
                ></app-modelo-dispositivo-selector>
              </div>
            </section>

            <!-- Frecuencia -->
            <section class="inputs-group">
              <mat-form-field style="width: 100%">
                <mat-label>Frecuencia de comunicación (minutos)</mat-label>
                <input matInput formControlName="frecReporte" type="number" />
                <mat-icon matPrefix>timer</mat-icon>
              </mat-form-field>
            </section>
          </app-content-card>

          <!-- Cliente -->
          <app-content-card title="Cliente" icon="business" color="orange">
            <div class="client-section-wrapper">
              <div class="client-fields">
                <section class="inputs-group">
                  @if (!paramsService.getParams()['idCliente']) {
                    <div style="width: 100%">
                      <label class="field-label">Cliente</label>
                      <div style="display: flex; gap: 8px">
                        <app-cliente-selector
                          formControlName="idCliente"
                          style="flex: 1"
                          [filterModules]="[
                            'moduloActivos',
                            'moduloVehiculos',
                            'moduloColectivos',
                            'moduloEmergenciasMedicas',
                          ]"
                          [showCrearBtn]="
                            helper.tienePermiso(
                              'Administración - Crear clientes'
                            )
                          "
                        ></app-cliente-selector>
                      </div>
                    </div>
                  }
                </section>
              </div>

              @if (idCliente) {
                <div class="client-hierarchy">
                  <app-jerarquia-cliente
                    [idCliente]="idCliente"
                  ></app-jerarquia-cliente>
                </div>
              }
            </div>

            @if (tipoCliente !== 'Final') {
              <section class="inputs-group" style="flex-direction: column">
                <!-- Horarios de atención -->
                <div style="width: 100%">
                  <app-config-horarios-atencion
                    formControlName="configHorariosAtencion"
                    [idClienteFinal]="idCliente"
                  ></app-config-horarios-atencion>
                </div>

                <!-- Horarios de atención técnica -->
                <div style="width: 100%">
                  <app-config-horarios-atencion
                    formControlName="configHorariosAtencionTecnica"
                    titulo="Clientes que Atienden Servicios Técnicos"
                    [idClienteFinal]="idCliente"
                  ></app-config-horarios-atencion>
                </div>

                <mat-checkbox
                  color="primary"
                  formControlName="puedeSolicitarServicioTecnico"
                >
                  Puede solicitar servicio técnico (permite que el cliente
                  genere solicitudes de servicio técnico desde su app)
                </mat-checkbox>
              </section>
            }
          </app-content-card>

          <!-- Servicios Contratados -->
          @if (servicios) {
            <app-content-card
              title="Servicios Contratados"
              icon="build"
              color="purple"
            >
              <section class="inputs-group">
                <ng-select
                  [fixedPlaceholder]="true"
                  [items]="servicios"
                  bindLabel="nombre"
                  bindValue="_id"
                  formControlName="idServiciosContratados"
                  [multiple]="true"
                  placeholder="Servicios contratados"
                  style="width: 100%"
                  appendTo="body"
                >
                  <ng-template ng-option-tmp let-item="item">
                    <div class="row-flex-start" style="gap: 8px">
                      @if (item.icono) {
                        <img
                          [src]="item.icono"
                          alt="Logo"
                          style="width: 30px; height: 30px; border-radius: 50%"
                        />
                      }
                      <span>{{ item.nombre }}</span>
                    </div>
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    <div class="row-flex-start" style="gap: 8px">
                      @if (item.icono) {
                        <img
                          [src]="item.icono"
                          alt="Logo"
                          style="width: 15px; height: 15px; border-radius: 50%"
                        />
                      }
                      <span>{{ item.nombre }}</span>
                    </div>
                  </ng-template>
                </ng-select>
              </section>
            </app-content-card>
          }

          <!-- Configuración GPRS -->
          @if (form.value.tipo === 'GPRS') {
            <app-content-card
              title="Configuración GPRS"
              icon="sim_card"
              color="green"
            >
              <!-- UniqueId / IMEI -->
              <section class="inputs-group">
                <mat-checkbox
                  color="primary"
                  [checked]="tieneImei"
                  (change)="tieneImei = $event.checked"
                  style="align-self: center"
                >
                  Tiene IMEI
                </mat-checkbox>

                @if (!tieneImei) {
                  <mat-form-field style="width: 100%">
                    <mat-label>ID Único</mat-label>
                    <input matInput formControlName="uniqueId" />
                    <mat-icon matPrefix>fingerprint</mat-icon>
                  </mat-form-field>
                } @else {
                  <mat-form-field style="width: 100%">
                    <mat-label>IMEI</mat-label>
                    <input
                      matInput
                      maxlength="15"
                      minlength="14"
                      formControlName="uniqueId"
                    />
                    <mat-icon matPrefix>fingerprint</mat-icon>
                    @if (form.get('uniqueId').invalid) {
                      <mat-error>IMEI inválido</mat-error>
                    }
                  </mat-form-field>
                }
              </section>

              <!-- SIM 1 -->
              <section
                class="inputs-group"
                [formGroup]="sim1"
                style="flex-direction: column; gap: 0"
              >
                <label class="field-label">SIM 1</label>
                <app-selector-sim-disponible
                  [conSim]="conSim(1)"
                  (seleccion)="alSeleccionarSim(1, $event)"
                ></app-selector-sim-disponible>

                <section class="inputs-group" style="gap: 0.5em">
                  <mat-form-field style="width: 100%">
                    <mat-label>ICCID</mat-label>
                    <input
                      matInput
                      formControlName="iccid"
                      (blur)="checkSimDuplicado(1)"
                    />
                    <mat-icon matPrefix>sim_card</mat-icon>
                  </mat-form-field>

                  <mat-form-field style="width: 100%">
                    <mat-label>Número de teléfono</mat-label>
                    <input
                      matInput
                      formControlName="numero"
                      type="tel"
                      (blur)="checkSimDuplicado(1)"
                    />
                    <mat-icon matPrefix>phone</mat-icon>
                  </mat-form-field>
                </section>

                @if (cargandoCheckSim1) {
                  <div class="sim-check-loading">
                    <mat-spinner diameter="18"></mat-spinner>
                    <span>Verificando duplicados...</span>
                  </div>
                }
                @if (duplicadoSim1 && !cargandoCheckSim1) {
                  <div class="sim-duplicado-warning">
                    <mat-icon>warning</mat-icon>
                    <span>
                      Esta SIM ya está asignada al
                      {{ tipoLabelSim(1) }}
                      <strong>{{ duplicadoSim1.nombre }}</strong>
                      (SIM {{ duplicadoSim1.simNumero }})
                    </span>
                    <button irxBoton="peligro" (click)="moverSim(1)">
                      <mat-icon>drive_file_move</mat-icon>
                      Mover aquí
                    </button>
                  </div>
                }

                <section class="inputs-group" style="gap: 0.5em">
                  <ng-select
                    [items]="operadores"
                    formControlName="operador"
                    placeholder="Operador"
                    appendTo="body"
                    notFoundText="Sin resultados"
                    style="width: 100%"
                  ></ng-select>

                  <mat-form-field style="width: 100%">
                    <mat-label>APN</mat-label>
                    <input
                      type="text"
                      placeholder="datos.personal.com"
                      matInput
                      formControlName="apn"
                      [matAutocomplete]="auto"
                    />
                    <mat-icon matPrefix>wifi</mat-icon>
                    <mat-autocomplete #auto="matAutocomplete">
                      @for (
                        option of filteredOptionsSim1 | async;
                        track option
                      ) {
                        <mat-option [value]="option">{{ option }}</mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </section>

                <section class="inputs-group" style="gap: 0.5em">
                  <mat-form-field style="width: 100%">
                    <mat-label>Usuario</mat-label>
                    <input matInput formControlName="usuario" type="text" />
                    <mat-icon matPrefix>person</mat-icon>
                  </mat-form-field>

                  <mat-form-field style="width: 100%">
                    <mat-label>Password</mat-label>
                    <input matInput formControlName="password" type="text" />
                    <mat-icon matPrefix>lock</mat-icon>
                  </mat-form-field>
                </section>
              </section>

              <!-- SIM 2 toggle -->
              <section class="inputs-group">
                <app-button
                  matType="mat-raised-button"
                  [color]="mostrarSim2 ? 'neutral' : 'primary'"
                  [icon]="mostrarSim2 ? 'expand_less' : 'add'"
                  [text]="mostrarSim2 ? 'Ocultar SIM 2' : 'Agregar SIM 2'"
                  (click)="mostrarSim2 = !mostrarSim2"
                ></app-button>
              </section>

              <!-- SIM 2 -->
              @if (mostrarSim2) {
                <section
                  class="inputs-group"
                  [formGroup]="sim2"
                  style="flex-direction: column; gap: 0"
                >
                  <label class="field-label">SIM 2</label>
                  <app-selector-sim-disponible
                    [conSim]="conSim(2)"
                    (seleccion)="alSeleccionarSim(2, $event)"
                  ></app-selector-sim-disponible>

                  <section class="inputs-group">
                    <mat-form-field style="width: 100%">
                      <mat-label>ICCID</mat-label>
                      <input
                        matInput
                        formControlName="iccid"
                        (blur)="checkSimDuplicado(2)"
                      />
                      <mat-icon matPrefix>sim_card</mat-icon>
                    </mat-form-field>

                    <mat-form-field style="width: 100%">
                      <mat-label>Número de teléfono</mat-label>
                      <input
                        matInput
                        formControlName="numero"
                        type="tel"
                        (blur)="checkSimDuplicado(2)"
                      />
                      <mat-icon matPrefix>phone</mat-icon>
                    </mat-form-field>
                  </section>

                  @if (cargandoCheckSim2) {
                    <div class="sim-check-loading">
                      <mat-spinner diameter="18"></mat-spinner>
                      <span>Verificando duplicados...</span>
                    </div>
                  }
                  @if (duplicadoSim2 && !cargandoCheckSim2) {
                    <div class="sim-duplicado-warning">
                      <mat-icon>warning</mat-icon>
                      <span>
                        Esta SIM ya está asignada al
                        {{ tipoLabelSim(2) }}
                        <strong>{{ duplicadoSim2.nombre }}</strong>
                        (SIM {{ duplicadoSim2.simNumero }})
                      </span>
                      <button irxBoton="peligro" (click)="moverSim(2)">
                        <mat-icon>drive_file_move</mat-icon>
                        Mover aquí
                      </button>
                    </div>
                  }

                  <section class="inputs-group">
                    <ng-select
                      [items]="operadores"
                      formControlName="operador"
                      placeholder="Operador"
                      appendTo="body"
                      notFoundText="Sin resultados"
                      style="width: 100%"
                    ></ng-select>

                    <mat-form-field style="width: 100%">
                      <mat-label>APN</mat-label>
                      <input
                        type="text"
                        placeholder="datos.personal.com"
                        matInput
                        formControlName="apn"
                        [matAutocomplete]="auto1"
                      />
                      <mat-icon matPrefix>wifi</mat-icon>
                      <mat-autocomplete #auto1="matAutocomplete">
                        @for (
                          option of filteredOptionsSim2 | async;
                          track option
                        ) {
                          <mat-option [value]="option">{{ option }}</mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  </section>

                  <section class="inputs-group">
                    <mat-form-field style="width: 100%">
                      <mat-label>Usuario</mat-label>
                      <input matInput formControlName="usuario" type="text" />
                      <mat-icon matPrefix>person</mat-icon>
                    </mat-form-field>

                    <mat-form-field style="width: 100%">
                      <mat-label>Password</mat-label>
                      <input matInput formControlName="password" type="text" />
                      <mat-icon matPrefix>lock</mat-icon>
                    </mat-form-field>
                  </section>
                </section>
              }
            </app-content-card>
          }

          <!-- Configuración Qualcomm -->
          @if (form.value.tipo === 'Qualcomm') {
            <app-content-card
              title="Configuración Qualcomm"
              icon="device_hub"
              color="green"
              [formGroup]="qualcomm"
            >
              <section class="inputs-group">
                <mat-form-field style="width: 100%">
                  <mat-label>Número Serial</mat-label>
                  <input matInput formControlName="serialNumber" />
                  <mat-icon matPrefix>qr_code</mat-icon>
                </mat-form-field>
              </section>
            </app-content-card>
          }

          <!-- Configuración LoRaWAN (T1000-B) -->
          <!-- El T1000-B ES el dispositivo LoRaWAN: no se elige un nodo aparte,
               los datos de radio se cargan acá y el backend provisiona el
               device en ChirpStack al guardar. -->
          @if (form.value.tipo === 'T1000-B') {
            <app-content-card
              title="Configuración LoRaWAN"
              icon="router"
              color="green"
              [formGroup]="t1000b"
            >
              <section class="inputs-group">
                <mat-form-field style="width: 100%">
                  <mat-label>DevEUI</mat-label>
                  <input
                    matInput
                    formControlName="deveui"
                    maxlength="16"
                    (blur)="
                      verificarDeveuiExistente(t1000b.get('deveui').value)
                    "
                  />
                  <mat-icon matPrefix>qr_code</mat-icon>
                  <mat-error>16 caracteres hexadecimales (0-9, A-F).</mat-error>
                  @if (!deveuiEditable) {
                    <mat-hint>
                      El devEUI identifica al equipo y no se puede cambiar. Para
                      reemplazarlo, dar de baja este tracker y crear uno nuevo.
                    </mat-hint>
                  }
                </mat-form-field>

                <ng-select
                  [items]="deviceProfiles"
                  bindValue="id"
                  bindLabel="name"
                  formControlName="deviceProfileId"
                  placeholder="Device Profile"
                  appendTo="body"
                  notFoundText="Sin resultados"
                  style="width: 100%"
                ></ng-select>
              </section>

              @if (verificandoDeveui) {
                <app-loading
                  text="Verificando DevEUI..."
                  [diameter]="24"
                ></app-loading>
              }
              @if (trackerConflicto && !verificandoDeveui) {
                <section class="inputs-group">
                  <span class="warn-text">
                    Este DevEUI ya está asignado al tracker "{{
                      trackerConflicto.nombre ||
                        trackerConflicto.identificacion
                    }}".
                  </span>
                </section>
              }

              <section class="inputs-group">
                <mat-form-field style="width: 100%">
                  <mat-label>AppKey (OTAA)</mat-label>
                  <input matInput formControlName="appkey" maxlength="32" />
                  <mat-icon matPrefix>key</mat-icon>
                  <button
                    irxBotonIcono
                    matSuffix
                    type="button"
                    tooltip="Generar una AppKey aleatoria"
                    (click)="generarAppkey()"
                  >
                    <mat-icon>casino</mat-icon>
                  </button>
                  <mat-error>
                    32 caracteres hexadecimales (0-9, A-F). No es el devEUI.
                  </mat-error>
                  <mat-hint>
                    La provee el fabricante. 32 caracteres hexadecimales.
                  </mat-hint>
                </mat-form-field>

                <mat-form-field style="width: 100%">
                  <mat-label>Sin comunicación (horas)</mat-label>
                  <input
                    matInput
                    type="number"
                    min="0"
                    formControlName="tiempoLimiteComunicacion"
                  />
                  <mat-icon matPrefix>schedule</mat-icon>
                  <mat-hint>
                    Horas sin reportar antes de generar el evento.
                  </mat-hint>
                </mat-form-field>
              </section>

              <section class="inputs-group">
                <mat-checkbox
                  color="primary"
                  [checked]="mostrarAvanzadosLora"
                  (change)="mostrarAvanzadosLora = $event.checked"
                  style="align-self: center"
                >
                  Opciones avanzadas
                </mat-checkbox>
              </section>

              @if (mostrarAvanzadosLora) {
                <section class="inputs-group">
                  <mat-form-field style="width: 100%">
                    <mat-label>JoinEUI</mat-label>
                    <input matInput formControlName="joineui" maxlength="16" />
                    <mat-icon matPrefix>fingerprint</mat-icon>
                    <mat-error>
                      16 caracteres hexadecimales (0-9, A-F).
                    </mat-error>
                  </mat-form-field>
                </section>
                <section class="inputs-group">
                  <mat-checkbox color="primary" formControlName="isDisabled">
                    Deshabilitado en el Network Server
                  </mat-checkbox>
                  <mat-checkbox color="primary" formControlName="skipFcntCheck">
                    Omitir chequeo de frame counter
                  </mat-checkbox>
                </section>
              }
            </app-content-card>
          }
        </mat-card-content>

        <mat-divider></mat-divider>

        <!-- Botones -->
        <mat-card-actions class="actions-create">
          <app-button
            matType="mat-fab extended"
            color="neutral"
            (click)="dialogRef.close()"
            text="Cancelar"
            icon="close"
          ></app-button>
          <app-button
            matType="mat-fab extended"
            [disabled]="!form.valid || guardando"
            color="primary"
            text="Guardar"
            icon="save"
            type="submit"
          ></app-button>
        </mat-card-actions>
      </form>
    }
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
